module.exports = __webpack_public_path__ + "static/media/logs.691f711c.jpg";